export const PricingType = {
    AD_HOC: 'AD_HOC',
    HOURLY: 'HOURLY',
    WEEKLY_PRICING: 'WEEKLY',
    MONTHLY_PRICING: 'MONTHLY',
};
